export const SIDEBAR_WIDTH = 250;

export const SIDEBAR_SMALL_WIDTH = 90;

export const HEADER_HEIGHT = 71.1;

export const MOBILE_WIDTH = 480;

export const TABLET_WIDTH = 768;

export const DESKTOP_WIDTH = 1024;

export const DESKTOP_LARGE_WIDTH = 1280;

export const SPINNER_SIZE = 48;
